import { lazy, Suspense } from "react";
import { SEO } from "@/components/SEO";
import ArqNavigation from "@/components/arqera/ArqNavigation";
import ArqHero from "@/components/arqera/ArqHero";
import ArqProblem from "@/components/arqera/ArqProblem";
import ArqServices from "@/components/arqera/ArqServices";
import ArqHowItWorks from "@/components/arqera/ArqHowItWorks";
import ArqProofBar from "@/components/arqera/ArqProofBar";
import ArqEngagementShapes from "@/components/arqera/ArqEngagementShapes";
import ArqAbout from "@/components/arqera/ArqAbout";
import ArqFAQ from "@/components/arqera/ArqFAQ";
import ArqBooking from "@/components/arqera/ArqBooking";
import ArqFooter from "@/components/arqera/ArqFooter";
import CookieConsent from "@/components/CookieConsent";
import SkipToContent from "@/components/SkipToContent";

const ChatWidget = lazy(() => import("@/components/ChatWidget"));

export default function Index() {
  return (
    <div id="top" className="bg-arq-bg text-arq-text font-body">
      <SEO
        title="ArqeraAI | AI Security & Privacy Engineering for Regulated Teams"
        description="ArqeraAI finds, fixes, and validates AI, application, and privacy risk for regulated organizations — with audit-ready evidence."
        ogTitle="ArqeraAI | Secure AI Adoption for Regulated Industries"
        ogDescription="Practitioner-led AI security, application security, and privacy & consent enforcement. We secure your AI. Then we scale it."
        canonical="https://arqeraai.com/"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "ArqeraAI",
          url: "https://www.arqeraai.com",
          description: "AI security and privacy engineering for regulated industries",
          serviceType: ["AI Security", "Application Security", "Privacy & Consent Enforcement", "Third Party Risk"],
        }}
      />
      <SkipToContent />
      <ArqNavigation />
      <main id="main-content" tabIndex={-1} className="focus:outline-none">
        <ArqHero />
        <ArqProblem />
        <ArqServices />
        <ArqHowItWorks />
        <ArqProofBar />
        <ArqEngagementShapes />
        <ArqAbout />
        <ArqFAQ />
        <ArqBooking />
      </main>
      <ArqFooter />
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
      <CookieConsent />
    </div>
  );
}
